export enum InviteMode {
  Automatically = "Automatically",
  Manually = "Manually",
}
